import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import axios from "axios";

const API_URL = process.env.BFF_URL;

class UserService {

  getUsers() {
    return http.get(API_URL + "/app/users", { headers: authHeader() })
  }

  getUserStores(id) {
    return http.get(API_URL + `/app/users/${id}/stores`, { headers: authHeader() })
  }

  create(user) {
    return http.post(API_URL + "/app/users", user, { headers: authHeader() });
  }

  update(id, user) {
    return http.put(API_URL + `/app/users/${id}`, user, { headers: authHeader() });
  }

  findById(id) {
    return http.get(API_URL + `/app/users/${id}`, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(API_URL + `/app/users/${id}`, { headers: authHeader() });
  }

  activate(id, data) {
    return http.put(API_URL + "/app/users/" + id + "/activate", data, { headers: authHeader() })
  }

  addCredentials(id, data) {
    return http.post(API_URL + "/users/" + id + "/credentials", data, { headers: authHeader() })
  }

  updatePassword(id, data) {
    return http.put(API_URL + "/users/" + id + "/credentials", data, { headers: authHeader() })
  }

  permissions(userId, storeId) {
    return axios
      .get(API_URL + `/app/users/${userId}/stores/${storeId}/permissions`, {
        headers: authHeader()
      })
  }

  handleResponse(response) {
    return response
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/service/user.service.js